// How the EUSDR questions page names statuses, marks, rulings and times; the download uses the
// same words (eusdrWorkbook.ts).
import type {
  EusdrMark,
  EusdrQuestion,
  EusdrRuling,
  EusdrStatus,
} from "../../api/hooks/useEusdrQuestions";

export const STATUSES: { status: EusdrStatus; label: string }[] = [
  { status: "awaiting", label: "Not answered" },
  { status: "discussion", label: "In discussion" },
  { status: "answered", label: "Answered" },
];

export const statusLabel = (s: EusdrStatus): string =>
  STATUSES.find((x) => x.status === s)?.label ?? s;

export const MARK_LABEL: Record<EusdrMark, string> = {
  answered: "Marked answered",
  reopened: "Reopened",
};

export const LETTERS = ["A", "B"] as const;
export const RULINGS: EusdrRuling[] = ["a", "b"];

/** "A applies: 1.5 m", or "Neither applies as written". */
export const rulingLabel = (q: EusdrQuestion, ruling: EusdrRuling): string => {
  if (ruling === "neither") return "Neither applies as written";
  const i = RULINGS.indexOf(ruling);
  return `${LETTERS[i]} applies: ${q.clauses[i]?.says ?? ""}`;
};

/** "28 Oct 2026 at 14:05". */
export const when = (iso: string): string => {
  const d = new Date(iso);
  const date = d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  const time = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  return `${date} at ${time}`;
};
